const scrollContainer = document.querySelector(
	'.servicos-clientes__container-cards'
);

let isDown = false;
let startX;
let scrollLeft;

scrollContainer.addEventListener('mousedown', (e) => {
	isDown = true;
	scrollContainer.classList.add('active');
	startX = e.pageX - scrollContainer.offsetLeft;
	scrollLeft = scrollContainer.scrollLeft;
});

scrollContainer.addEventListener('mouseleave', () => {
	isDown = false;
	scrollContainer.classList.remove('active');
});

scrollContainer.addEventListener('mouseup', () => {
	isDown = false;
	scrollContainer.classList.remove('active');
});

scrollContainer.addEventListener('mousemove', (e) => {
	if (!isDown) return;
	e.preventDefault();
	const x = e.pageX - scrollContainer.offsetLeft;
	const walk = (x - startX) * 9;
	scrollContainer.scrollLeft = scrollLeft - walk;
});
